import React, { useEffect, setState } from 'react';
import PropTypes from 'prop-types';

import Input from '../Input';
import Select from '../Select';
import Checkbox from '../Checkbox';
import validators from '../../helpers/validators';
import bestOptions from './bestOptions';
import { Form as RawForm, CheckboxContainer, CheckboxContainerTitle, Error } from './styles';

const Form = function ({
  defaultValues,
  register,
  errors,
}) {
  return (
    <RawForm>
      <Input
        label="Name:"
        name="name"
        defaultValue={defaultValues.name}
        forwardRef={register({ validate: validators.field })}
        placeholder="Type your name"
        alert={errors.name && { type: 'error', message: errors.name.message }}
      />
      <Input
        label="E-mail:"
        name="email"
        type="email"
        autoComplete="email"
        defaultValue={defaultValues.email}
        forwardRef={register({ validate: validators.email })}
        placeholder="Type your e-mail"
        alert={errors.email && { type: 'error', message: errors.email.message }}
      />
      <Input
        label="Company:"
        name="company"
        defaultValue={defaultValues.company}
        forwardRef={register({ validate: validators.field })}
        placeholder="Type your company"
        alert={errors.company && { type: 'error', message: errors.company.message }}
      />
      <Select
        label="Job Role:"
        name="jobRole"
        defaultValue={defaultValues.jobRole}
        forwardRef={register({ validate: validators.select })}
        alert={errors.jobRole && { type: 'error', message: errors.jobRole.message }}
      >
        <option value="">Select</option>
        <option>CxO</option>
        <option>IT/Innovation/R&amp;D Manager</option>
        <option>Marketing/Sales Manager</option>
        <option>LoB/Product Manager</option>
        <option>HR Manager</option>
        <option>Consultant/Analyst/Engineer</option>
        <option>Developer</option>
        <option>Other</option>
      </Select>
      <CheckboxContainer>
        <CheckboxContainerTitle>
          Select the best options for what you're looking for in InStation
        </CheckboxContainerTitle>
        {bestOptions.map((interest, index) => (
          <Checkbox 
            name={'interests'}
            key={index} 
            label={interest}
            defaultValue={interest}
            forwardRef={register({validate: validators.options})}
          />
        ))}
        {errors.interests && (
          <Error>
            {errors.interests.message}
          </Error>
        )}
      </CheckboxContainer>
    </RawForm>
  );
};

Form.propTypes = {
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    jobRole: PropTypes.string,
    options: PropTypes.array,
  }).isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default Form;
